import { render, staticRenderFns } from "./footerDepedencias.vue?vue&type=template&id=65805228&scoped=true"
import script from "./footerDepedencias.vue?vue&type=script&lang=js"
export * from "./footerDepedencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65805228",
  null
  
)

export default component.exports